export const SUPPORTED_LANGUAGES = ['en', 'es'];

export const employeeLanguages = (employees: Array<Employee>) => {
  const languageCounts: Record<string, number> = employees.reduce((counts, employee) => {
    const languagePreference = employee.Contact.Person.languagePreference ?? 'en';
    if (counts[languagePreference]) {
      counts[languagePreference] += 1;
    } else {
      counts[languagePreference] = 1;
    }

    return counts;
  }, {} as Record<string, number>);

  const languagesToSupport = Object.keys(languageCounts).filter((language) =>
    SUPPORTED_LANGUAGES.includes(language),
  );
  const defaultLanguage = languagesToSupport.length === 1 ? languagesToSupport[0] : 'en';

  if (Object.keys(languageCounts).length > 0 && languagesToSupport.length === 0) {
    // If we are here, the employee(s) most likely have an unsupported language preference
    // so we will show the english box and allow translate
    languagesToSupport.push(defaultLanguage);
  }

  return {
    languageCounts,
    languagesToSupport,
    defaultLanguage,
  };
};
